import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { components } from "react-select";
import {
  CheckUniqueLedgerPayloadType,
  GetAutoUniqueNumberPayloadType,
  PaymentOptionsType,
} from "../../../../commonTypes/clientSettingsTypes";
import { ImageDataType } from "../../../../commonTypes/fileManagerTypes";
import {
  GetCityListDataPayloadType,
  GetCountryListDataPayloadType,
  GetStateListDataPayloadType,
} from "../../../../commonTypes/masterDataTypes";
import {
  getBankAccountNumberType,
  getGstInfoType,
  verifyPanType,
  verifyTanType,
} from "../../../../commonTypes/serviceTypes";
import { OptionsType } from "../../../../commonTypes/universalTypes";
import useDebounce from "../../../../customHooks/useDebounce";
import { checkUniqueLedgerAction, getAutoUniqueNumberGenerationAction, resetAutoUniqueNumberGenerationData } from "../../../../redux/clientSettings";
import { BusinessAddressListType } from "../../../../redux/clientSettings/clientSettingTypes";
import {
  getAllCityAction,
  getAllCountryAction,
  getAllStateAction,
  resetCityList,
  resetStateList,
  resetStateListTotalCount,
} from "../../../../redux/masterData";
import {
  CityListTypes,
  CountryListTypes,
  StateListTypes,
} from "../../../../redux/masterData/masterTypes";
import { RootState } from "../../../../redux/rootReducers";
import {
  authorizedVerifyPanAction,
  getBankAccountInfoAction,
  getGstInfoAction,
  resetAuthorizedPanVerifyData,
  resetBankAccountDetails,
  resetGstDetails,
  resetPanVerifyData,
  resetServicesError,
  resetServicesSucces,
  resetTanVerifyData,
  verifyPanAction,
  verifyTanAction,
} from "../../../../redux/services";
import {
  BankAccountInfoType,
  PanVerifyType,
  TanVerifyType,
  gstDetails,
} from "../../../../redux/services/serviceTypes";
import {
  isEmailValid,
  preventEnterKey,
  returnInputFieldLength,
} from "../../../../utils/commonFunctions";
import ImagePreview from "../../../FileManager/Files/ImagePreview";
import { TrashIcon, UploadNew } from "../../../Icon";
import {
  Checkbox,
  CircularAvatar,
  Loader,
  RollingLoader,
  UploadModal,
} from "../../../commons";
import BusinessDetails from "./BusinessDetails";
import ContactDetails from "./ContactDetails";
import OtherDetails from "./OtherDetails";
import PaymentsDetails from "./PaymentsDetails";

export type BusinessDetailsType = {
  invoiceHeading?: string;
  gst?: string;
  pan?: string;
  msmeRegistrationNo?: string;
  tan?: string;
  cin?: string;
  legalName: string;
  tradeName: string;
  notes?: string;
  registrationType?: string;
  registrationDate?: string;
  constitutionOfBusiness?: string;
  companyStatus?: string;
  tin?: string;
  gstUsername?: string;

};

export type ContactDetailsType = {
  addressOne?: string;
  addressTwo?: string;
  city?: string;
  pin?: string;
  country?: string;
  mobile?: string;
  telephone?: string;
  email?: string;
  website?: string;
};

export type GstSignatoryDetails = {
  authorizedSignatoryPanNumber?: string;
  authorizedSignatoryName?: string;
  authorizedSignatoryEmail?: string;
  authorizedSignatoryPhoneNumber?: string | number | null;
}
export type OtherDetailsType = {
  udyogAadhar?: string;
  professionalTaxEmployer?: string;
  professionalTaxEmpoyee?: string;
  serviceTaxNumber?: string;
  iecCode?: string;
  iacRegistration?: string;
  startUpIndiaNumber?: string;
  epfoNumber?: string;
  esicNumber?: string;
};

export type ErrorTypes = {
  panError?: string;
  legalNameError?: string;
  tradeNameError?: string;
  emailError?: string;
  addressStateError?: string;
  uniqueNumberError?: string;
  countryError?: string;
  cityError?: string;
  authorizedPanError?: string;
};

type AppProps = {
  token: string | null;
  history: any;
  success: number | null;
  handleAddBusinessAddress?: (data: any) => void;
  handleEditBusinessAddress?: (data: any) => void;
  businessAddressData?: BusinessAddressListType;
  isEdit?: boolean;
  gstFetching?: boolean;
  company_name?: string;
  ledgerMessage: string | null;
  uniqueLedgerFetching: boolean;
  gstError?: string | null;
  gstDetails?: gstDetails | null;
  countryList: CountryListTypes[] | [];
  countryListTotalCount: number;
  countryFetching: boolean;
  stateList: StateListTypes[] | [];
  stateListTotalCount: number;
  stateFetching: boolean;
  isState: null | boolean;
  cityList: CityListTypes[] | [];
  cityListTotalCount: number;
  cityFetching: boolean;
  isCity: null | boolean;
  panVerifyDetails: PanVerifyType | null;
  authorizedPanVerifyDetails: PanVerifyType | null;
  tanVerifyDetails: TanVerifyType | null;
  bankAccountDetails: BankAccountInfoType | null;
  dispatchCheckUniqueLedgerAction: (data: CheckUniqueLedgerPayloadType) => void;
  dispatchGetBankAccountInfoAction: (data: getBankAccountNumberType) => void;
  dispatchGstDetailsAction?: (data: getGstInfoType) => void;
  dispatchResetGstDetails?: () => void;
  dispatchResetServicesError?: () => void;
  dispatchResetServicesSucces?: () => void;
  dispatchGetCountryListAction: (data: GetCountryListDataPayloadType) => void;
  dispatchGetAllStateAction: (data: GetStateListDataPayloadType) => void;
  dispatchGetAllCityAction: (data: GetCityListDataPayloadType) => void;
  dispatchVerifyPanAction: (data: verifyPanType) => void;
  dispatchAuthorizedVerifyPanAction: (data: verifyPanType) => void;
  dispatchVerifyTanAction: (data: verifyTanType) => void;
  dispatchResetStateListTotalCount: () => void;
  dispatchResetStateList: () => void;
  dispatchResetCityList: () => void;
  dispatchResetBankAccountDetails: () => void;
  dispatchResetPanVerifyData: () => void;
  dispatchResetAuthorizedPanVerifyData: () => void;
  dispatchResetTanVerifyData: () => void;
  servicesError: string | null;
  dispatchGetAutoUniqueNumberCheckAction: (data: GetAutoUniqueNumberPayloadType) => void;
  autoUniqueNumberGenerationData: any;
  dispatchResetAutoUniqueNumberGenerationData: () => void;
};
type UniqueType = {
  uniqueNumber?: string | undefined;
};

type CheckUniqueErrorType = {
  uniqueNumberError: string;
  isUniqueError: boolean;
};

const BusinessAddressForm = ({
  token,
  history,
  success,
  handleAddBusinessAddress,
  handleEditBusinessAddress,
  businessAddressData,
  isEdit,
  ledgerMessage,
  uniqueLedgerFetching,
  dispatchCheckUniqueLedgerAction,
  dispatchGstDetailsAction,
  dispatchResetServicesError,
  dispatchResetGstDetails,
  gstDetails,
  gstError,
  gstFetching,
  countryList,
  countryFetching,
  countryListTotalCount,
  stateList,
  stateListTotalCount,
  stateFetching,
  isState,
  cityList,
  cityListTotalCount,
  isCity,
  panVerifyDetails,
  tanVerifyDetails,
  bankAccountDetails,
  dispatchGetBankAccountInfoAction,
  dispatchResetServicesSucces,
  dispatchGetCountryListAction,
  dispatchGetAllStateAction,
  dispatchGetAllCityAction,
  dispatchResetStateList,
  dispatchResetCityList,
  dispatchVerifyPanAction,
  dispatchVerifyTanAction,
  dispatchResetBankAccountDetails,
  dispatchResetPanVerifyData,
  dispatchResetAuthorizedPanVerifyData,
  dispatchResetTanVerifyData,
  servicesError,
  authorizedPanVerifyDetails,
  dispatchAuthorizedVerifyPanAction,
  dispatchGetAutoUniqueNumberCheckAction,
  autoUniqueNumberGenerationData,
  dispatchResetAutoUniqueNumberGenerationData,

}: AppProps) => {
  const client_code = history?.location?.state?.client_code;
  const [unique, setUnique] = useState<UniqueType>({
    uniqueNumber: "",
  });
  const [isApiCall, setIsApiCall] = useState(false);
  const [isApiCityCall, setIsApiCityCall] = useState(false);
  const [checkUniqueError, setCheckUniqueError] =
    useState<CheckUniqueErrorType>({
      uniqueNumberError: "",
      isUniqueError: false,
    });
  const [uniqueCheck, setUniqueCheck] = useState<CheckUniqueLedgerPayloadType>({
    client_code: null,
    token,
    ledger_number: undefined,
  });
  const [showSignatureUploadModal, setShowSignatureUploadModal] =
    useState<boolean>(false);
  const [ledgerApiMessage, setLedgerApiMessage] = useState<string>("");
  const [companyLogo, setCompanyLogo] = useState({});
  const [upiFile, setUpiFile] = useState({});
  const [signature, setSignature] = useState<any>({});
  const [showUpiModal, setShowUpiModal] = useState<boolean>(false);
  const [showUploadLogoModal, setShowUploadLogoModal] =
    useState<boolean>(false);
  const [defaultAddress, setDefaultAddress] = useState(false);
  const [addressState, setAddressState] = useState<OptionsType>({
    value: null,
    label: "Choose State...",
  });
  const [finalStateList, setFinalStateList] = useState<any>([]);
  // country
  const [countrySelectedList, setCountrySelectedList] = useState<any>([]);
  const [finalCountry, setCountry] = useState<any>({
    value: null,
    label: "Select..",
  });
  // city
  const [selectedCityList, setSelectedCityList] = useState<any>({
    value: null,
    label: "Select...",
  });
  const [finalCityList, setFinalCityList] = useState<any>([]);

  const [offset, setOffset] = useState<number>(0);
  const [stateOffset, setStateOffset] = useState<number>(0);
  const [cityOffset, setCityOffset] = useState<number>(0);

  const [text, setText] = useState<string>("");
  const [stateText, setStateText] = useState<string>("");
  const [cityText, setCityText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [loadCondition, setLoadCondition] = useState(true);
  const [businessDetails, setBusinessDetails] = useState<BusinessDetailsType>({
    invoiceHeading: "",
    gst: "",
    pan: "",
    msmeRegistrationNo: "",
    tan: "",
    cin: "",
    legalName: "",
    tradeName: "",
    notes: "",
    registrationType: "",
    registrationDate: "",
    constitutionOfBusiness: "",
    companyStatus: "",
    tin: "",
    gstUsername: "",
  });
  const [gstSignatoryDeatils, setGstSignatoryDetails] = useState<GstSignatoryDetails>({
    authorizedSignatoryPanNumber: "",
    authorizedSignatoryName: "",
    authorizedSignatoryEmail: "",
    authorizedSignatoryPhoneNumber: ""
  })
  const [contactDetails, setContactDetails] = useState<ContactDetailsType>({
    addressOne: "",
    addressTwo: "",
    city: "",
    pin: "",
    country: "",
    mobile: "",
    telephone: "",
    email: "",
    website: "",
  });

  const [otherDetails, setOtherDetails] = useState<OtherDetailsType>({
    udyogAadhar: "",
    professionalTaxEmployer: "",
    professionalTaxEmpoyee: "",
    serviceTaxNumber: "",
    iecCode: "",
    iacRegistration: "",
    startUpIndiaNumber: "",
    epfoNumber: "",
    esicNumber: "",
  });

  const [paymentDetails, setPaymentDetails] = useState<PaymentOptionsType>({
    online_payment_details: {
      online_payment_link: "",
    },
    cheque_details: {
      cheque_payable_to: "", //STCO Consulting LLP.
    },
    bank_details: {
      account_no: "",
      bank_name: "",
      beneficiary_name: "",
      ifsc_code: "",
      swift_code: "",
      bank_branch_address: "",
      city: "",
      ifscError: "",
    },
    upi_details: {
      upi_file: "",
      upi_number: "",
      upi_image: undefined,
      upi_id: undefined,
    },
  });

  const [formError, setFormError] = useState<ErrorTypes>({
    panError: "",
    legalNameError: "",
    tradeNameError: "",
    emailError: "",
    addressStateError: "",
    uniqueNumberError: "",
    countryError: "",
    cityError: "",
    authorizedPanError: ""
  });
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  const [imageDetails, setImageDetails] = useState<ImageDataType>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [previewData, setPreviewData] = useState<any[]>([]);
  const [autoUniqueNumberCheck, setAutoUniqueNumberCheck] = useState<boolean>(false);
  const { uniqueNumber } = unique;
  const { uniqueNumberError } = formError;
  useEffect(() => {
    dispatchResetServicesError?.();
    dispatchResetGstDetails?.();
    dispatchResetServicesSucces?.();
    dispatchResetStateList();
    dispatchResetCityList();
    dispatchResetBankAccountDetails();
    dispatchResetPanVerifyData();
    dispatchResetAuthorizedPanVerifyData()
    dispatchResetTanVerifyData();
    dispatchResetAutoUniqueNumberGenerationData();
    if(token) {
      let finalData = {
        token,
        clientCode: client_code,
        general_settings_type: "ledger_number",
      };
      dispatchGetAutoUniqueNumberCheckAction(finalData);
    }
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    if(autoUniqueNumberGenerationData && Object.keys(autoUniqueNumberGenerationData)?.length > 0){
      setAutoUniqueNumberCheck(autoUniqueNumberGenerationData?.is_enable === 1);
    } else {
      setAutoUniqueNumberCheck(false);
    }
  }, [autoUniqueNumberGenerationData])
  useEffect(() => {
    if (gstDetails) {
      setBusinessDetails((prevState) => ({
        ...prevState,
        gst: gstDetails?.gstin ? gstDetails?.gstin : "",
        legalName: gstDetails?.legal_name_of_business
          ? gstDetails?.legal_name_of_business
          : "",
        tradeName: gstDetails?.trade_name ? gstDetails?.trade_name : "",
        registrationDate: gstDetails?.registration_date
          ? gstDetails?.registration_date
          : "",
        registrationType: gstDetails?.registration_type
          ? gstDetails?.registration_type
          : "",
        constitutionOfBusiness: gstDetails?.constitution_of_business
          ? gstDetails?.constitution_of_business
          : "",
        companyStatus: gstDetails?.status ? gstDetails?.status : "",
      }));
      setContactDetails((prevState) => ({
        ...prevState,
        addressOne: gstDetails?.address1 ? gstDetails?.address1 : "",
        addressTwo: gstDetails?.address2 ? gstDetails?.address2 : "",
        city: gstDetails?.district ? gstDetails?.district : "",
        country: gstDetails?.district ? "India" : "",
        pin: gstDetails?.pincode ? gstDetails?.pincode?.toString() : "",
      }));
      setAddressState(
        gstDetails?.state_code
          ? {
            value: gstDetails?.state_code,
            label: gstDetails?.state_code,
          }
          : { value: "", label: "Choose State..." }
      );
      setFormError((prev) => ({
        ...prev,
        ...(gstDetails?.legal_name_of_business && { legalNameError: "" }),
        ...(gstDetails?.state_code && { addressStateError: "" }),
        ...(gstDetails?.trade_name && { tradeNameError: "" }),
      }));
    } else if (!businessAddressData?.gst_number) {
      setBusinessDetails({
        invoiceHeading: "",
        gst: "",
        pan: "",
        msmeRegistrationNo: "",
        tan: "",
        tin: "",
        cin: "",
        legalName: "",
        tradeName: "",
        notes: "",
        registrationType: "",
        registrationDate: "",
        constitutionOfBusiness: "",
        companyStatus: "",
        gstUsername: "",
      });
      setContactDetails({
        addressOne: "",
        addressTwo: "",
        city: "",
        pin: "",
        country: "",
        mobile: "",
        telephone: "",
        email: "",
      });
      setAddressState({
        value: "",
        label: "Choose State...",
      });
    }
    //eslint-disable-next-line
  }, [gstDetails]);

  useEffect(() => {
    if (isEdit && businessAddressData) {
      setBusinessDetails((prevState) => ({
        ...prevState,
        gst: businessAddressData?.gst_number
          ? businessAddressData?.gst_number
          : "",
        pan: businessAddressData?.pan_number
          ? businessAddressData?.pan_number
          : "",
        msmeRegistrationNo: businessAddressData?.msme_registration_no
          ? businessAddressData?.msme_registration_no
          : "",
        tan: businessAddressData?.tan_number
          ? businessAddressData?.tan_number
          : "",
        cin: businessAddressData?.cin_number
          ? businessAddressData?.cin_number
          : "",
        legalName: businessAddressData?.legal_name
          ? businessAddressData?.legal_name
          : "",
        tradeName: businessAddressData?.trade_name
          ? businessAddressData?.trade_name
          : "",
        notes: businessAddressData?.notes ? businessAddressData?.notes : "",
        invoiceHeading: businessAddressData?.invoice_heading
          ? businessAddressData?.invoice_heading
          : "",
        registrationDate: businessAddressData?.registration_date
          ? businessAddressData?.registration_date
          : "",
        registrationType: businessAddressData?.registration_type
          ? businessAddressData?.registration_type
          : "",
        constitutionOfBusiness: businessAddressData?.constitution_of_business
          ? businessAddressData?.constitution_of_business
          : "",
        companyStatus: businessAddressData?.company_status
          ? businessAddressData?.company_status
          : "",
        tin: businessAddressData?.tin_number
          ? businessAddressData?.tin_number
          : "",
        gstUsername: businessAddressData?.gst_username
          ? businessAddressData?.gst_username
          : "",
      }));

      setContactDetails((prevState) => ({
        ...prevState,
        addressOne: businessAddressData?.address1
          ? businessAddressData?.address1
          : "",
        addressTwo: businessAddressData?.address2
          ? businessAddressData?.address2
          : "",
        city: businessAddressData?.city ? businessAddressData?.city : "",
        pin: businessAddressData?.pincode
          ? businessAddressData?.pincode?.toString()
          : "",
        country: businessAddressData?.country
          ? businessAddressData?.country
          : "",
        mobile: businessAddressData?.mobile ? businessAddressData?.mobile : "",
        telephone: businessAddressData?.telephone
          ? businessAddressData?.telephone
          : "",
        email: businessAddressData?.email ? businessAddressData?.email : "",
        website: businessAddressData?.website
          ? businessAddressData?.website
          : "",
      }));

      setGstSignatoryDetails((prevState) => ({
        ...prevState,
        authorizedSignatoryPanNumber: businessAddressData?.authorized_signatory_pan_number ? businessAddressData?.authorized_signatory_pan_number : "",
        authorizedSignatoryName: businessAddressData?.authorized_signatory_name ? businessAddressData?.authorized_signatory_name : "",
        authorizedSignatoryEmail: businessAddressData?.authorized_signatory_email ? businessAddressData?.authorized_signatory_email : "",
        authorizedSignatoryPhoneNumber: businessAddressData?.authorized_signatory_phone_number ? businessAddressData?.authorized_signatory_phone_number : ""
      }));

      setOtherDetails((prevState) => ({
        ...prevState,
        udyogAadhar: businessAddressData?.udyog_aadhar_number
          ? businessAddressData?.udyog_aadhar_number
          : "",
        professionalTaxEmployer: businessAddressData?.employer_professional_tax
          ? businessAddressData?.employer_professional_tax
          : "",
        professionalTaxEmpoyee: businessAddressData?.person_professional_tax
          ? businessAddressData?.person_professional_tax
          : "",
        serviceTaxNumber: businessAddressData?.service_tax_number
          ? businessAddressData?.service_tax_number
          : "",
        iecCode: businessAddressData?.iec_code_number
          ? businessAddressData?.iec_code_number
          : "",
        iacRegistration: businessAddressData?.iec_code_number
          ? businessAddressData?.iec_code_number
          : "",
        startUpIndiaNumber:
          businessAddressData?.startup_india_registration_number
            ? businessAddressData?.startup_india_registration_number
            : "",
        epfoNumber: businessAddressData?.epfo_number
          ? businessAddressData?.epfo_number
          : "",
        esicNumber: businessAddressData?.esic_number
          ? businessAddressData?.esic_number
          : "",
      }));
      if (businessAddressData?.signature) {
        setSignature(businessAddressData?.signature);
      }
      setUpiFile(businessAddressData?.payment_details?.upi_details?.upi_image);
      setCompanyLogo(businessAddressData?.logo_details ?? {});

      if (businessAddressData?.is_default_address) {
        setDefaultAddress(true);
      }
      if (!businessAddressData?.is_default_address) {
        setDefaultAddress(false);
      }
      if (businessAddressData?.country) {
        setCountry({
          value: businessAddressData?.country?.value,
          label: businessAddressData?.country?.label,
        });
      }
      if (businessAddressData?.state) {
        setAddressState({
          value: businessAddressData?.state?.value,
          label: businessAddressData?.state?.label,
        });
      }
      if (businessAddressData?.city) {
        setSelectedCityList({
          value: businessAddressData?.city?.value,
          label: businessAddressData?.city?.label,
        });
      }

      setUnique({
        uniqueNumber: businessAddressData?.ledger_number?.toString(),
      });
      if (businessAddressData?.payment_details) {
        setPaymentDetails(businessAddressData?.payment_details);
      }
    }
    //eslint-disable-next-line
  }, [businessAddressData]);
  //
  // country dropdown things

  useEffect(() => {
    const finalCountryData = countryList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (offset > 0) {
      setCountrySelectedList([...countrySelectedList, ...finalCountryData]);
    } else {
      setCountrySelectedList(finalCountryData);
    }
  }, [countryList]);

  useEffect(() => {
    dispatchResetCityList();
    dispatchResetStateList();
    if (token) {
      let finalCountryData = {
        token,
        offset,
        limit,
        search_term: text,
      };
      if (offset <= countryListTotalCount) {
        dispatchGetCountryListAction(finalCountryData);
      }
    }
    //eslint-disable-next-line
  }, [offset]);

  useEffect(() => {
    if (
      paymentDetails?.bank_details?.account_no ||
      paymentDetails?.bank_details?.ifsc_code
    ) {
      dispatchResetBankAccountDetails();
      dispatchResetServicesError?.();
    }
    //eslint-disable-next-line
  }, [
    paymentDetails?.bank_details?.account_no,
    paymentDetails?.bank_details?.ifsc_code,
  ]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      search_term: text,
    };
    dispatchGetCountryListAction(finalData);
  };

  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          search_term: text,
        };
        dispatchGetCountryListAction(finalData);
      }
    },
    500,
    [text]
  );

  // preview  signature
  useEffect(() => {
    if (previewData?.length) {
      setImageDetails({
        ...previewData[0],
        imageUrl: blobBaseUrl + previewData[0].file_url + "?" + blobToken,
        downloadImage: previewData[0].file_url,
        fileType: previewData[0].file_type,
        finalFileName: previewData[0].file_name,
      });
    }
    //eslint-disable-next-line
  }, [previewData]);
  const handleOpenPreview = (data: any) => {
    setPreviewData([data]);
    setShowImagePreview(!showImagePreview);
  };

  const handlePreviewImageModal = () => {
    setShowImagePreview(!showImagePreview);
  };

  const handleChangeCountry = (data: any) => {
    setCountry({
      value: data?.value,
      label: data?.label,
    });

    if (data?.value && formError.countryError) {
      setFormError((prevState) => ({
        ...prevState,
        countryError: "",
      }));
    }
    setFormError((prevState) => ({
      ...prevState,
      addressStateError: "",
    }));
  };

  const onMenuClose = () => {
    setLoadCondition(true);
  };
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  // state dropdown
  useEffect(() => {
    dispatchResetCityList();
    if (finalCountry?.value) {
      let finalData: GetStateListDataPayloadType = {
        token,
        limit,
        offset: stateOffset,
        search_term: stateText,
        country_id: finalCountry.value,
      };

      if (stateOffset === 0) {
        dispatchGetAllStateAction(finalData);

        setIsApiCall(true);
      } else {
        dispatchGetAllStateAction(finalData);
        setStateOffset(0);
        setIsApiCall(true);
      }
    }
    //eslint-disable-next-line
  }, [finalCountry?.value]);

  useEffect(() => {
    dispatchResetCityList();
    if (isState === false && !stateFetching && finalCountry?.value) {
      let finalData: GetCityListDataPayloadType = {
        token,
        limit,
        offset: cityOffset,
        search_term: cityText,
        country_id: finalCountry?.value,
      };
      if (cityOffset === 0) {
        dispatchGetAllCityAction(finalData);
      } else {
        setCityOffset(0);
      }
    }
    //eslint-disable-next-line
  }, [isState]);

  useEffect(() => {
    const finalStateData = stateList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (stateOffset > 0) {
      setFinalStateList([...finalStateList, ...finalStateData]);
    } else {
      setFinalStateList(finalStateData);
    }
    //eslint-disable-next-line
  }, [stateList]);

  useEffect(() => {
    dispatchResetCityList();
    if (token && stateOffset != 0) {
      let finalStateData = {
        token,
        offset: stateOffset,
        limit,
        search_term: stateText,
        country_id: finalCountry?.value,
      };
      if (stateOffset <= stateListTotalCount) {
        dispatchGetAllStateAction(finalStateData);
      }
    }
    //eslint-disable-next-line
  }, [stateOffset]);

  const fetchData = (search: string) => {
    const finalData = {
      token,
      offset: stateOffset,
      limit,
      search_term: stateText,
      country_id: finalCountry?.value,
    };

    dispatchGetAllStateAction(finalData);
  };

  useDebounce(
    () => {
      if (stateText && isApiCall) {
        fetchData(stateText);
      } else if (isApiCall) {
        const finalData = {
          token,
          offset: stateOffset,
          limit,
          search_term: stateText,
          country_id: finalCountry?.value,
        };
        dispatchGetAllStateAction(finalData);
      }
    },
    500,
    [stateText]
  );

  const handleChangeState = (data: any) => {
    setAddressState({
      value: data?.value,
      label: data?.label,
    });
    if (data?.value && formError.addressStateError) {
      setFormError((prevState) => ({
        ...prevState,
        addressStateError: "",
      }));
    }
    setFormError((prevState) => ({
      ...prevState,
      cityError: "",
    }));
  };
  // city
  useEffect(() => {
    let finalData: GetCityListDataPayloadType = {
      token,
      limit,
      offset: cityOffset,
      search_term: cityText,
      state_id: addressState?.value,
    };
    if (addressState?.value) {
      if (cityOffset === 0) {
        dispatchGetAllCityAction(finalData);

        setIsApiCityCall(true);
      } else {
        dispatchGetAllCityAction(finalData);
        setCityOffset(0);
        setIsApiCityCall(true);
      }
    }
    //eslint-disable-next-line
  }, [addressState?.value]);

  useEffect(() => {
    const finalCityData = cityList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (cityOffset > 0) {
      setFinalCityList([...finalCityList, ...finalCityData]);
    } else {
      setFinalCityList(finalCityData);
    }
    //eslint-disable-next-line
  }, [cityList]);

  useEffect(() => {
    if (token && cityOffset !== 0) {
      let finalcityData = {
        token,
        offset: cityOffset,
        limit,
        search_term: cityText,
        state_id: addressState?.value,
      };
      if (cityOffset <= cityListTotalCount) {
        dispatchGetAllCityAction(finalcityData);
      }
    }
    //eslint-disable-next-line
  }, [cityOffset]);

  const fetchCityData = (search: string) => {
    const finalData = {
      token,
      offset: cityOffset,
      limit,
      search_term: cityText,
      state_id: addressState?.value,
    };
    dispatchGetAllCityAction(finalData);
  };

  useDebounce(
    () => {
      if (cityText && isApiCityCall) {
        fetchCityData(cityText);
      } else if (isApiCityCall) {
        const finalData = {
          token,
          offset: cityOffset,
          limit,
          search_term: cityText,
          state_id: addressState?.value,
        };
        dispatchGetAllCityAction(finalData);
      }
    },
    500,
    [cityText]
  );

  const handleChangeCity = (data: any) => {
    setSelectedCityList({
      value: data?.value,
      label: data?.label,
    });

    if (data?.value && formError.cityError) {
      setFormError((prevState) => ({
        ...prevState,
        cityError: "",
      }));
    }
  };

  useEffect(() => {
    if (ledgerMessage?.length) {
      setLedgerApiMessage(ledgerMessage);
    }

    if (ledgerMessage?.length && ledgerMessage?.includes("not")) {
      setCheckUniqueError((prevState) => ({
        ...prevState,
        isUniqueError: true,
      }));
    } else if (ledgerMessage?.length && !ledgerMessage?.includes("not")) {
      setCheckUniqueError((prevState) => ({
        ...prevState,
        isUniqueError: false,
      }));
    }
  }, [ledgerMessage]);

  useDebounce(
    () => {
      if (
        uniqueCheck.client_code &&
        uniqueCheck.ledger_number &&
        uniqueCheck.token
      ) {
        dispatchCheckUniqueLedgerAction(uniqueCheck);
      }
    },
    500,
    [uniqueCheck]
  );

  const getGstDetails = (e: any) => {
    e.preventDefault();
    const finalData = {
      token,
      gstNumber: businessDetails?.gst,
    };
    if (businessDetails?.gst && token) {
      dispatchGstDetailsAction?.(finalData);
    }
  };

  const getPanDetails = (e: any) => {
    e.preventDefault();
    dispatchResetPanVerifyData();
    if (businessDetails?.pan && token) {
      const finalData = {
        token,
        panNo: businessDetails?.pan,
      };
      dispatchVerifyPanAction?.(finalData);
    }
  };

  const authorizedGetPanDetails = (e: any) => {
    e.preventDefault();
    dispatchResetAuthorizedPanVerifyData();
    if (gstSignatoryDeatils?.authorizedSignatoryPanNumber && token) {
      const finalData = {
        token,
        panNo: gstSignatoryDeatils.authorizedSignatoryPanNumber,
      };
      dispatchAuthorizedVerifyPanAction?.(finalData);
    }
  };

  const getTanDetails = (e: any) => {
    e.preventDefault();
    dispatchResetTanVerifyData();
    if (businessDetails?.tan && token) {
      const finalData = {
        token,
        tanNo: businessDetails?.tan,
      };
      dispatchVerifyTanAction?.(finalData);
    }
  };

  const getBankDetails = (e: any) => {
    e.preventDefault();
    dispatchResetBankAccountDetails();
    dispatchResetServicesError?.();
    if (
      paymentDetails?.bank_details?.ifsc_code &&
      paymentDetails?.bank_details?.account_no &&
      token
    ) {
      const finalData = {
        token,
        panNo: businessDetails?.pan,
        ifsc_no: paymentDetails?.bank_details?.ifsc_code,
        account_number: paymentDetails?.bank_details?.account_no,
      };
      dispatchGetBankAccountInfoAction?.(finalData);
    }
  };

  const handleToggleUploadLogoModal = (e: any) => {
    e.preventDefault();
    setShowUploadLogoModal(!showUploadLogoModal);
  };
  const handleUpiToggleUploadModal = (e: any) => {
    e.preventDefault();
    setShowUpiModal(!showUpiModal);
  };
  const handleSignatureToggleUploadModal = (e: any) => {
    e.preventDefault();
    setShowSignatureUploadModal(!showSignatureUploadModal);
  };
  const handleBusinessDetailsChange = (e: any) => {
    const {
      panError,
      legalNameError,
      tradeNameError,
      addressStateError,
      countryError,
      cityError,
    } = formError;
    e.target.name === "pan" && dispatchResetPanVerifyData();
    e.target.name === "tan" && dispatchResetTanVerifyData();
    if (e.target.name === "legalName" || e.target.name === "tradeName") {
      setBusinessDetails((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    } else if (e.target.name === "tin") {
      const newValue =
        e.target.value.length > e.target.maxLength
          ? e.target.value.slice(0, e.target.maxLength)
          : e.target.value;
      setBusinessDetails((prevState) => ({
        ...prevState,
        [e.target.name]: newValue,
      }));
    } else if (
      e.target.name === "gst" ||
      e.target.name === "pan" ||
      e.target.name === "tan" ||
      e.target.name === "cin"
    ) {
      dispatchResetServicesSucces?.();
      setBusinessDetails((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value.toUpperCase(),
      }));
    } else {
      setBusinessDetails((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }

    if (e.target.name === "pan" && panError) {
      setFormError((prevState) => ({
        ...prevState,
        panError: "",
      }));
    } else if (e.target.name === "legalName" && legalNameError) {
      setFormError((prevState) => ({
        ...prevState,
        legalNameError: "",
      }));
    } else if (e.target.name === "tradeName" && tradeNameError) {
      setFormError((prevState) => ({
        ...prevState,
        tradeNameError: "",
      }));
    } else if (addressState.value && addressStateError) {
      setFormError((prevState) => ({
        ...prevState,
        addressStateError: "",
      }));
    } else if (finalCountry.value && countryError) {
      setFormError((prevState) => ({
        ...prevState,
        countryError: "",
      }));
    } else if (selectedCityList.value && cityError) {
      setFormError((prevState) => ({
        ...prevState,
        cityError: "",
      }));
    }
  };

  const handleContactDetailsChange = (e: any) => {
    setContactDetails((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    if (e.target.name === "email" && formError.emailError) {
      setFormError((prevState) => ({
        ...prevState,
        emailError: "",
      }));
    }
  };
  const handleGstChange = (e: any) => {
    if (e.target.name === "authorizedSignatoryPanNumber") {
      dispatchResetAuthorizedPanVerifyData()
      setGstSignatoryDetails((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value?.toUpperCase(),
      }));
    }
    else if (e?.targrt?.name === "authorizedSignatoryEmail") {
      if (e?.taget?.value?.length && !isEmailValid(e?.target?.value)) {

        setFormError((prevState) => ({
          ...prevState,
          authorizedPanError: "Email not valid",
        }));
      }
      else {
        setFormError((prevState) => ({
          ...prevState,
          authorizedPanError: "",
        }));
      }
    }
    else {
      setGstSignatoryDetails((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const handleOtherDetailsChange = (e: any) => {
    setOtherDetails((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleUploadFile = (data: any) => {
    setShowUploadLogoModal(false);
    setCompanyLogo(data);
  };

  const handleUpiUploadFile = (data: any) => {
    setUpiFile(data);
    setShowUpiModal(false);
  };
  const handleSignatureUploadFile = (data: any) => {
    setSignature(data);
    setShowSignatureUploadModal(false);
  };

  const handleDeleteUploadedLogo = () => {
    setCompanyLogo({});
  };
  const handleDeleteUploadedUpi = () => {
    setUpiFile({});
  };
  const handleDeleteUploadedSignature = () => {
    setSignature({});
  };
  const handleSubmitFinalData = () => {
    const { pan, legalName, tradeName } = businessDetails;
    const { email } = contactDetails;
    if (
      !ledgerApiMessage?.includes("not")  &&
      pan &&
      legalName &&
      tradeName &&
      email &&
      (uniqueNumber || autoUniqueNumberCheck) &&
      ((isState &&
        addressState?.value &&
        finalCountry?.value &&
        selectedCityList?.value) ||
        (!isState && finalCountry?.value) ||
        (isState && addressState?.value && finalCountry?.value && !isCity))
    ) {
      let finalData = {
        ...businessDetails,
        ...contactDetails,
        ...otherDetails,
        ...gstSignatoryDeatils,
        payment_details: {
          ...paymentDetails,
          upi_details: { ...paymentDetails?.upi_details, upi_image: upiFile },
        },
        ledgerNumber: uniqueNumber ? uniqueNumber : "",
        isDefaultAddress: defaultAddress ? 1 : 0,
        logo_details: companyLogo,
        state: addressState?.label,
        country: finalCountry?.label,
        city: selectedCityList?.label,
        signature: signature,
      };
      if (isEdit) {
        let finalEditData = {
          ...finalData,
          payment_details: {
            ...finalData?.payment_details,
            verifyBankDetails: paymentDetails?.bank_details?.ifscError?.length
              ? null
              : bankAccountDetails?.account_exists?.length
                ? bankAccountDetails
                : businessAddressData?.payment_details?.verifyBankDetails
                  ?.account_exists?.length
                  ? businessAddressData?.payment_details?.verifyBankDetails
                  : null,
          },
          pan_details:
            panVerifyDetails?.status === "VALID"
              ? panVerifyDetails
              : businessAddressData?.pan_details?.status === "VALID" &&
                businessAddressData?.pan_number === businessDetails?.pan
                ? businessAddressData?.pan_details
                : null,
          authorized_signatory_pan_details:
            authorizedPanVerifyDetails?.status === "VALID"
              ? authorizedPanVerifyDetails
              : businessAddressData?.authorized_signatory_pan_details?.status === "VALID" &&
                businessAddressData?.authorized_signatory_pan_details?.pan === gstSignatoryDeatils?.authorizedSignatoryPanNumber
                ? businessAddressData?.authorized_signatory_pan_details
                : null,
          tan_details: tanVerifyDetails?.nameOrgn?.length
            ? tanVerifyDetails
            : businessAddressData?.tan_details?.nameOrgn
              ? businessAddressData?.tan_details
              : null,
          ledger_id: businessAddressData?.ledger_id,
        };
        handleEditBusinessAddress?.(finalEditData);
      } else {
        const finalAddData = {
          ...finalData,
          payment_details: {
            ...finalData?.payment_details,
            verifyBankDetails: paymentDetails?.bank_details?.ifscError?.length
              ? null
              : bankAccountDetails?.account_exists?.length
                ? bankAccountDetails
                : null,
          },
          pan_details:
            panVerifyDetails?.status === "VALID" ? panVerifyDetails : null,
          authorized_signatory_pan_details:
            authorizedPanVerifyDetails?.status === "VALID" ? authorizedPanVerifyDetails : null,
          tan_details: tanVerifyDetails?.nameOrgn?.length
            ? tanVerifyDetails
            : null,
        };
        handleAddBusinessAddress?.(finalAddData);
      }
    } else {
      setFormError((prevState) => ({
        ...prevState,
        ...(!uniqueNumber && {
          uniqueNumberError: "Unique Number is required",
        }),
        ...(!pan && { panError: "PAN is required" }),
        ...(!legalName && { legalNameError: "Legal Name is required" }),
        ...(!tradeName && { tradeNameError: "Trade Name is required" }),
        ...(!email && { emailError: "Email is required" }),
        ...(!addressState.value && {
          addressStateError: "Please choose a state!",
        }),
        ...(!finalCountry.value && {
          countryError: "Please choose a country!",
        }),
        ...(!selectedCityList.value && {
          cityError: "Please choose a city!",
        }),
      }));
    }
  };

  const handleMaxLengthCheck = (e: any) => {
    if (e.target.value.length > e.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength);
      setUnique((prevState) => ({
        ...prevState,
        uniqueNumber: e.target.value,
      }));
    }
  };

  const handleResetData = () => {
    setLedgerApiMessage("");
    setUnique((prevState) => ({
      ...prevState,
      uniqueNumber: "",
    }));
    setCheckUniqueError({
      uniqueNumberError: "",
      isUniqueError: false,
    });
  };

  const handlecheckUniqueChange = (e: any) => {
    handleResetData();
    const { uniqueNumberError } = checkUniqueError;
    let targetName = e.target.name;
    if (targetName === "uniqueNumber" && e.target.value.length) {
      setFormError((prev) => ({
        ...prev,
        uniqueNumberError: "",
      }));
      let finalData = {
        token,
        client_code,
        ledger_number: e.target.value,
      };
      if (!isEdit) {
        setUniqueCheck(finalData);
      } else if (
        isEdit &&
        targetName === "uniqueNumber" &&
        e.target.value != businessAddressData?.ledger_number
      ) {
        setUniqueCheck(finalData);
        handleResetData();
      } else {
        handleResetData();
        setUniqueCheck({
          client_code: null,
          token,
          ledger_number: undefined,
        });
      }
    }

    if (targetName === "uniqueNumber") {
      setUnique((prevState) => ({
        ...prevState,
        uniqueNumber: e.target.value,
      }));
    }

    if (targetName === "uniqueNumber" && uniqueNumberError) {
      setCheckUniqueError((prevState) => ({
        ...prevState,
        uniqueNumberError: "",
      }));
    }
  };

  const changeDefaultAddressCheckBox = () => {
    setDefaultAddress(!defaultAddress);
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="content-area">
          {!autoUniqueNumberCheck || isEdit ? (
          <form>
          <div className="form-group">
            <div className="row">
              <div className="col-md-4">
                <label
                  htmlFor="uniqueNumber"
                  className={uniqueNumber ? "active" : ""}
                >
                  Enter Unique Number*
                </label>
                <div className="d-flex flex-row position-relative">
                  <input
                    type="number"
                    className={`form-control ${!!uniqueNumberError ? "error-border" : null
                      }`}
                    name="uniqueNumber"
                    onKeyDown={preventEnterKey}
                    value={uniqueNumber}
                    autoFocus={!isEdit}
                    onChange={(e) => handlecheckUniqueChange(e)}
                    maxLength={12}
                    onInput={handleMaxLengthCheck}
                    onWheel={(event) => event.currentTarget.blur()}
                    disabled={autoUniqueNumberCheck && isEdit}
                  />
                  {uniqueLedgerFetching && <RollingLoader />}
                </div>
                {!!uniqueNumberError && (
                  <small className="text-danger">{uniqueNumberError}</small>
                )}
                {ledgerApiMessage?.includes("not") &&
                  !!uniqueNumber?.length &&
                  businessAddressData?.ledger_number.toString() !==
                  uniqueNumber && (
                    <small className="text-danger">
                      Unique number is already in use!
                    </small>
                  )}
              </div>
            </div>
            <span className="input-length">
              {returnInputFieldLength(uniqueNumber?.length, 12)}
            </span>
          </div>
        </form>
          ) : null}
          <div className="row">
            <div className="col-md-12">
              <h6>Business Details</h6>
            </div>
          </div>
          <BusinessDetails
            businessDetails={businessDetails}
            getGstDetails={getGstDetails}
            getPanDetails={getPanDetails}
            getTanDetails={getTanDetails}
            getBankDetails={getBankDetails}
            gstError={gstError}
            success={success}
            legalNameError={formError?.legalNameError}
            tradeNameError={formError?.tradeNameError}
            panError={formError?.panError}
            handleBusinessDetailsChange={handleBusinessDetailsChange}
            handleToggleUploadLogoModal={handleToggleUploadLogoModal}
            companyLogo={companyLogo}
            handleDeleteUploadedLogo={handleDeleteUploadedLogo}
            panVerifyDetails={panVerifyDetails}
            tanVerifyDetails={tanVerifyDetails}
            businessAddressData={businessAddressData}
            handleGstChange={handleGstChange}
            gstSignatoryDeatils={gstSignatoryDeatils}
            authorizedPanVerifyDetails={authorizedPanVerifyDetails}
            authorizedGetPanDetails={authorizedGetPanDetails}
          />


          {/* <GstSignatoryDeatils
         
          /> */}
          <div className="row">
            <div className="col-md-12">
              <h6 className="mb-0 mt-2">Contact Details</h6>
            </div>
          </div>
          <ContactDetails
            contactDetails={contactDetails}
            emailError={formError?.emailError}
            handleContactDetailsChange={handleContactDetailsChange}
            addressState={addressState}
            // handleStateChange={handleStateChange}
            addressStateError={formError?.addressStateError}
            onMenuClose={onMenuClose}
            Option={Option}
            countrySelectedList={countrySelectedList}
            countryFetching={countryFetching}
            finalCountry={finalCountry}
            setLoadCondition={setLoadCondition}
            setText={setText}
            setOffset={setOffset}
            handleChangeCountry={handleChangeCountry}
            limit={limit}
            handleChangeState={handleChangeState}
            finalStateList={finalStateList}
            stateFetching={stateFetching}
            finalCityList={finalCityList}
            selectedCityList={selectedCityList}
            handleChangeCity={handleChangeCity}
            setCityOffset={setCityOffset}
            setStateOffset={setStateOffset}
            setCityText={setCityText}
            setStateText={setStateText}
            countryError={formError?.countryError}
            cityError={formError?.cityError}
            isState={isState}
            isCity={isCity}
          />
          <div className="d-flex mt-3 mb-5">
            <Checkbox
              checked={defaultAddress}
              onPress={changeDefaultAddressCheckBox}
              disabled={businessAddressData?.is_default_address}
            />
            <small
              className="ml-2"
              style={{ fontSize: "14px", color: "#262a44" }}
            >
              Make this as Default Address
            </small>
          </div>
          <div className="row">
            <div className="col-md-12">
              <h6 className="mb-0 mt-2">Other Details</h6>
            </div>
          </div>
          <OtherDetails
            otherDetails={otherDetails}
            handleOtherDetailsChange={handleOtherDetailsChange}
          />
          <div className="row">
            <div className="col-md-3">
              <h6 className="mb-0 mt-2 mb-3">Payment Details</h6>
            </div>
          </div>
          <div className="row d-flex">
            <div className="col-md-3 form-group mt-2">
              <div>
                <label htmlFor="Account No">Online Payment Link</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="online_payment_link"
                  value={
                    paymentDetails?.online_payment_details?.online_payment_link
                  }
                  onChange={(e) => {
                    setPaymentDetails((prv: any) => {
                      return {
                        ...prv,
                        online_payment_details: {
                          online_payment_link: e?.target?.value,
                        },
                      };
                    });
                  }}
                />
              </div>
            </div>

            <div
              className="col-md-4"
              style={{ marginTop: "-15px", marginLeft: "103px" }}
            >
              <div className="form-group mt-3 d-flex flex-column">
                <label htmlFor="Account No">Upload Signature</label>
                {signature && Object.keys(signature).length ? (
                  <div className="pointer d-flex flex-row mt-2">
                    {/* eslint-disable-next-line */}
                    <a
                      onClick={() => handleOpenPreview(signature)}
                      target="_blank"
                      className="uploaded_file_name"
                    >
                      {signature?.file_name}
                    </a>
                    <div
                      className="ml-2"
                      onClick={handleDeleteUploadedSignature}
                    >
                      <TrashIcon />
                    </div>
                  </div>
                ) : (
                  <button
                    className="btn btn-sm btn-outline mt-2 w-50"
                    onClick={(e: any) => handleSignatureToggleUploadModal(e)}
                  >
                    <span>
                      <UploadNew /> Upload Signature
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-12 mb-3">
              <h6 className="mb-0 mt-2">Cheque Details</h6>
            </div>

            <div className="col-md-3 form-group ">
              <div>
                <label htmlFor="Account No">Cheque Payable To</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="cheque_payable_to"
                  value={paymentDetails?.cheque_details?.cheque_payable_to}
                  onChange={(e) => {
                    setPaymentDetails((prv: any) => {
                      return {
                        ...prv,
                        cheque_details: {
                          cheque_payable_to: e?.target?.value,
                        },
                      };
                    });
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            {" "}
            <div className="col-md-12 mt-2 ">
              <h6 className="mb-0 mt-2">Bank Details</h6>
            </div>
          </div>
          <PaymentsDetails
            setPaymentDetails={setPaymentDetails}
            paymentDetails={paymentDetails}
            handleToggleUploadFileModal={handleUpiToggleUploadModal}
            handleDeleteUploadedFile={handleDeleteUploadedUpi}
            upiFile={upiFile}
            getBankDetails={getBankDetails}
            bankAccountDetails={bankAccountDetails}
            businessAddressData={businessAddressData}
            servicesError={servicesError}
          />
        </div>
        <div className="row mt-3">
          <div className="col-md-12 text-right">
            <button
              className="btn btn-link"
              onClick={() => {
                history.goBack();
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSubmitFinalData}
              disabled={
                (!autoUniqueNumberCheck && !uniqueNumber?.trim()?.length) || 
                (!autoUniqueNumberCheck && !!uniqueNumberError) || 
                !!formError?.authorizedPanError || 
                (!autoUniqueNumberCheck && ledgerMessage?.includes("not") &&
                businessAddressData?.ledger_number.toString() !== uniqueNumber)
              }
            >
              {isEdit ? "Update Address" : "Submit"}
            </button>
          </div>
        </div>
      </div>
      {showUploadLogoModal && (
        <UploadModal
          modal={showUploadLogoModal}
          toggleModal={handleToggleUploadLogoModal}
          client_code={client_code}
          token={token}
          handleUploadFile={handleUploadFile}
          isDraggableModal
          acceptedFiles={"image/png, image/jpeg"}
          maxFileSize={2000000}
          supportedFiles="JPG/PNG"
        />
      )}
      {showUpiModal && (
        <UploadModal
          modal={showUpiModal}
          toggleModal={handleUpiToggleUploadModal}
          client_code={client_code}
          token={token}
          handleUploadFile={handleUpiUploadFile}
          isDraggableModal
          acceptedFiles={"image/png, image/jpeg"}
          maxFileSize={2000000}
          supportedFiles="JPG/PNG"
        />
      )}

      {showSignatureUploadModal && (
        <UploadModal
          modal={showSignatureUploadModal}
          toggleModal={handleSignatureToggleUploadModal}
          client_code={client_code}
          token={token}
          handleUploadFile={handleSignatureUploadFile}
          isDraggableModal
          acceptedFiles={"image/png, image/jpeg"}
          maxFileSize={1000000}
          supportedFiles="JPG/PNG"
        />
      )}
      {showImagePreview && imageDetails?.imageUrl?.length != 0 && (
        <ImagePreview
          resetImageUrl={handlePreviewImageModal}
          imageDetails={imageDetails}
        />
      )}
      {gstFetching && <Loader />}
    </div>
  );
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  ledgerMessage: state.clientSettings.ledgerMessage,
  uniqueLedgerFetching: state.clientSettings.uniqueLedgerFetching,
  gstDetails: state.services.gstDetails,
  gstFetching: state.services.fetching,
  gstError: state.services.error,
  success: state.services.success,
  countryList: state.masterData.countryList,
  countryListTotalCount: state.masterData.countryListTotalCount,
  countryFetching: state.masterData.countryFetching,
  stateList: state.masterData.stateList,
  stateListTotalCount: state.masterData.stateListTotalCount,
  stateFetching: state.masterData.stateFetching,
  cityList: state.masterData.cityList,
  cityListTotalCount: state.masterData.cityListTotalCount,
  cityFetching: state.masterData.cityFetching,
  isState: state.masterData.isState,
  isCity: state.masterData.isCity,
  panVerifyDetails: state.services.panVerifyDetails,
  authorizedPanVerifyDetails: state.services.authorizedPanVerifyDetails,
  tanVerifyDetails: state.services.tanVerifyDetails,
  bankAccountDetails: state.services.bankAccountDetails,
  servicesError: state.services.error,
  autoUniqueNumberGenerationData: state.clientSettings.autoUniqueNumberGenerationData,

});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchCheckUniqueLedgerAction: (data: CheckUniqueLedgerPayloadType) =>
    dispatch(checkUniqueLedgerAction(data)),
  dispatchGetCountryListAction: (data: GetCountryListDataPayloadType) =>
    dispatch(getAllCountryAction(data)),
  dispatchGetAllStateAction: (data: GetStateListDataPayloadType) =>
    dispatch(getAllStateAction(data)),
  dispatchGetAllCityAction: (data: GetCityListDataPayloadType) =>
    dispatch(getAllCityAction(data)),

  dispatchGstDetailsAction: (data: getGstInfoType) =>
    dispatch(getGstInfoAction(data)),
  dispatchVerifyTanAction: (data: verifyTanType) =>
    dispatch(verifyTanAction(data)),
  dispatchVerifyPanAction: (data: verifyPanType) =>
    dispatch(verifyPanAction(data)),
  dispatchAuthorizedVerifyPanAction: (data: verifyPanType) =>
    dispatch(authorizedVerifyPanAction(data)),
  dispatchGetBankAccountInfoAction: (data: getBankAccountNumberType) =>
    dispatch(getBankAccountInfoAction(data)),
  dispatchResetGstDetails: () => dispatch(resetGstDetails()),
  dispatchResetServicesError: () => dispatch(resetServicesError()),
  dispatchResetServicesSucces: () => dispatch(resetServicesSucces()),
  dispatchResetStateListTotalCount: () => dispatch(resetStateListTotalCount()),
  dispatchResetStateList: () => dispatch(resetStateList()),
  dispatchResetCityList: () => dispatch(resetCityList()),
  dispatchResetBankAccountDetails: () => dispatch(resetBankAccountDetails()),
  dispatchResetPanVerifyData: () => dispatch(resetPanVerifyData()),
  dispatchResetAuthorizedPanVerifyData: () => dispatch(resetAuthorizedPanVerifyData()),
  dispatchResetTanVerifyData: () => dispatch(resetTanVerifyData()),
  dispatchGetAutoUniqueNumberCheckAction: (data: GetAutoUniqueNumberPayloadType) => dispatch(getAutoUniqueNumberGenerationAction(data)),
  dispatchResetAutoUniqueNumberGenerationData: () =>
      dispatch(resetAutoUniqueNumberGenerationData()),
});

export default connect(
  mapStateTopProps,
  mapDispatchToProps
)(BusinessAddressForm);
